import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { InfoWarnError, MergeResponse } from '../../../model';

@Component({
  selector: 'app-info-warn-error-dialog',
  imports: [MatButtonModule, MatDialogModule, TranslateModule],
  templateUrl: './info-warn-error-dialog.component.html',
  styleUrls: ['./info-warn-error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoWarnErrorDialogComponent {
  constructor(
    public _dialogRef: MatDialogRef<InfoWarnErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: InfoWarnError,
  ) {}

  /**
   * Gets the message as MergeResponse if it's not a string.
   *
   * @memberof InfoWarnErrorDialogComponent
   */
  public get mergeResponse(): MergeResponse | null {
    return typeof this._data.message !== 'string' ? this._data.message : null;
  }

  /**
   * Closes the dialog and returns true to indicate confirmation.
   *
   * @memberof InfoWarnErrorDialogComponent
   */
  public confirmClick() {
    this._dialogRef.close(true);
  }

  /**
   * Closes the dialog and returns false to indicate cancellation.
   *
   * @memberof InfoWarnErrorDialogComponent
   */
  public cancelClick() {
    this._dialogRef.close(false);
  }
}
